import { CommandListCredits } from "./commands/cmdListCredits";
import { CommandCreateCredit, CreateCreditPayload } from "./commands/cmdCreateCredit";
import { CommandUpdateCredit, UpdateCreditPayload } from "./commands/cmdUpdateCredit";
import { CommandDeleteCredit } from "./commands/cmdDeleteCredit";
import { Credit } from "@models/credit.model";

export class CreditService {
  async list(contractId: number, params?: { budget_id?: number }): Promise<Credit[]> {
    try {
      return await new CommandListCredits().run(contractId, params);
    } catch (error) {
      console.error(`Failed to fetch credits for contract ${contractId}:`, error);
      return [];
    }
  }

  async create(contractId: number, payload: CreateCreditPayload): Promise<Credit> {
    try {
      return await new CommandCreateCredit().run(contractId, payload);
    } catch (error) {
      console.error(`Failed to create credit for contract ${contractId}:`, error);
      throw error;
    }
  }

  async update(contractId: number, creditId: number, payload: UpdateCreditPayload): Promise<Credit> {
    try {
      return await new CommandUpdateCredit().run(contractId, creditId, payload);
    } catch (error) {
      console.error(`Failed to update credit ${creditId}:`, error);
      throw error;
    }
  }

  async delete(contractId: number, creditId: number): Promise<Credit> {
    try {
      return await new CommandDeleteCredit().run(contractId, creditId);
    } catch (error) {
      console.error(`Failed to delete credit ${creditId}:`, error);
      throw error;
    }
  }
}
